import React from 'react';
import {
    Button,
    Stack,
    useTokens,
    styled,
} from '@barracuda-internal/bds-core';

// ---------------------------------------------------------------------------
// Styled pre block — monospace JSON viewer (3+ CSS properties → styled)
// ---------------------------------------------------------------------------
const JsonPre = styled('pre', {
    shouldForwardProp: (p) => !['bgColor', 'radius'].includes(p),
})(({ bgColor, radius }) => ({
    backgroundColor: bgColor,
    borderRadius: radius,
    padding: '8px',   // intentionally small; real token passed in sx below
    margin: 0,
    fontSize: 11,
    lineHeight: 1.5,
    overflowX: 'auto',
    overflowY: 'auto',
    maxHeight: '60vh',
    fontFamily: 'monospace',
    whiteSpace: 'pre',
}));

// ---------------------------------------------------------------------------
// Component
// ---------------------------------------------------------------------------

export default function RawJsonTab({ scan }) {
    const tokens = useTokens();
    const json = JSON.stringify(scan, null, 2);

    return (
        <Stack sx={{ gap: tokens.aliasesSpaceComponentDense }}>
            {/* Copy button — right-aligned */}
            <Stack
                direction="row"
                sx={{ justifyContent: 'flex-end' }}
            >
                <Button
                    bdsType="interactiveNeutral"
                    bdsSize="small"
                    onClick={() => navigator.clipboard.writeText(json)}
                >
                    Copy JSON
                </Button>
            </Stack>

            {/* JSON viewer */}
            <JsonPre
                bgColor={tokens.aliasesColorBgStaticContainerNeutral}
                radius={tokens.aliasesBorderRadiusDefault}
                sx={{ padding: tokens.aliasesSpaceContainerDefault }}
            >
                {json}
            </JsonPre>
        </Stack>
    );
}
